export default __webpack_public_path__ + "static/media/illi9.2da0e435.png";